import logo192 from '../assets/logo192.png';
import logo512 from '../assets/logo512.png';
import seal from '../assets/seal.png';
import sign from '../assets/sign.png';
import vLogo from '../assets/v-logo.png';
import veraRemovebgPreview from '../assets/vera-removebg-preview.png';
import vera from '../assets/vera.png';
import veramasaSymbol from '../assets/veramasa-symbol.png';
import veramasaText from '../assets/veramasa-text.png';
import veramasa from '../assets/veramasa.png';
import veramasaLogoo from '../assets/veramasaLogoo.png';
import veramasaLogo from '../assets/veramasalogo.png';

export const LocalImages = {
  logo192,
  logo512,
  seal,
  sign,
  vLogo,
  vera,
  veraRemovebgPreview,
  veramasa,
  veramasaSymbol,
  veramasaText,
  veramasaLogo,
  veramasaLogoo,
};
